document.addEventListener('DOMContentLoaded', function() {
  var overlay = document.getElementById('QuickViewModal');
  if (!overlay) return;
  var container = document.getElementById('QuickViewContainer');

  // Chiudi click fuori
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeQuickView();
  });
  // Chiudi tasto ESC
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeQuickView();
  });

  // Intercetta click sugli occhi
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.archelia-qv-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    openQuickView(btn.getAttribute('data-product-url'));
  });

  function openQuickView(url) {
    overlay.classList.add('is-open', 'is-loading');
    container.innerHTML = '';
    
    // Fetch section
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=archelia-quick-view')
      .then(res => res.text())
      .then(html => {
        // Estrai solo il div archelia-qv-layout dal testo scartando il resto html della section
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var layout = doc.querySelector('.archelia-qv-layout');
        
        if (layout) {
          container.innerHTML = layout.outerHTML;
          initQuickViewGalleries();
          initQuickViewForm();
          
          // Apply BXGY dynamic discount if requested via URL
          try {
            var urlObj = new URL(url, window.location.origin);
            var isBxgy = urlObj.searchParams.get('bxgy');
            var pctStr = urlObj.searchParams.get('pct');
            
            if (isBxgy === 'true' && pctStr) {
              var pct = parseInt(pctStr, 10);
              var select = document.querySelector('#QuickViewContainer .archelia-qv-variant-select');
              
              if (select && !isNaN(pct)) {
                Array.from(select.options).forEach(function(opt) {
                  var rawPrice = parseInt(opt.getAttribute('data-raw-price') || "0", 10);
                  var newRawPrice = Math.round(rawPrice * (100 - pct) / 100);
                  var oldMoney = opt.getAttribute('data-price');
                  var newMoney = newRawPrice <= 0 ? "Gratis" : ("€ " + (newRawPrice / 100).toFixed(2).replace('.', ','));
                  
                  opt.setAttribute('data-price', newMoney);
                  opt.setAttribute('data-compare', oldMoney);
                  
                  var parts = opt.textContent.split(' - ');
                  opt.textContent = parts[0] + ' - ' + newMoney;
                });
                select.dispatchEvent(new Event('change'));
              } else if (!isNaN(pct)) {
                // Modello senza select (singola variante testuale)
                var priceBlock = document.querySelector('#QuickViewContainer .archelia-qv-price-block');
                if (priceBlock) {
                  var rawPrice = parseInt(priceBlock.getAttribute('data-raw-price') || "0", 10);
                  var newRawPrice = Math.round(rawPrice * (100 - pct) / 100);
                  var oldMoney = priceBlock.getAttribute('data-price');
                  var newMoney = newRawPrice <= 0 ? "Gratis" : ("€ " + (newRawPrice / 100).toFixed(2).replace('.', ','));
                  
                  var html = '<span class="archelia-qv-price--sale">' + newMoney + '</span>';
                  html += '<span class="archelia-qv-price-compare">' + oldMoney + '</span>';
                  priceBlock.innerHTML = html;
                }
              }
            }
          } catch(e) { console.warn("Errore parsing parametri BXGY nella Quick View", e); }

          overlay.classList.remove('is-loading');
        } else {
          closeQuickView();
          window.location.href = url; // Fallback
        }
      })
      .catch(err => {
        console.error('Quick View err:', err);
        closeQuickView();
        window.location.href = url;
      });
  }

  window.closeQuickView = function() {
    overlay.classList.remove('is-open', 'is-loading');
    setTimeout(() => { container.innerHTML = ''; }, 300);
  };

  function initQuickViewGalleries() {
    var mainImg = document.querySelector('.archelia-qv-main-img');
    var thumbs = document.querySelectorAll('.archelia-qv-thumb');
    if (!mainImg || !thumbs.length) return;
    
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var src = this.getAttribute('data-img');
        if (src) {
          mainImg.src = src;
          thumbs.forEach(t => t.classList.remove('is-active'));
          this.classList.add('is-active');
        }
      });
    });
  }

  function initQuickViewForm() {
    // Aggiornamento prezzo e ID variante quando cambia la select
    var select = document.querySelector('.archelia-qv-variant-select');
    var priceBlock = document.querySelector('.archelia-qv-price-block');
    var atcBtn = document.querySelector('.archelia-qv-atc');
    
    if (select && priceBlock) {
      select.addEventListener('change', function() {
        var opt = this.options[this.selectedIndex];
        var price = opt.getAttribute('data-price');
        var compare = opt.getAttribute('data-compare');
        var available = opt.getAttribute('data-available') === 'true';
        
        var html = '<span class="' + (compare ? 'archelia-qv-price--sale' : '') + '">' + price + '</span>';
        if (compare) html += '<span class="archelia-qv-price-compare">' + compare + '</span>';
        priceBlock.innerHTML = html;
        
        atcBtn.disabled = !available;
        atcBtn.textContent = available ? 'Aggiungi al carrello' : 'Esaurito';
      });
    }

    // ATC AJAX standard del tema
    if (atcBtn) {
      atcBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var variantId = select ? select.value : this.getAttribute('data-atc-id');
        if (!variantId) return;
        
        this.textContent = 'Aggiunta...';
        this.style.opacity = '0.7';
        this.style.pointerEvents = 'none';
        
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity: 1, sections: ['cart-icon-bubble'] })
        })
        .then(res => res.json())
        .then(data => {
          this.textContent = '✓ Aggiunto';
          this.style.backgroundColor = '#4CAF50';
          this.style.borderColor = '#4CAF50';
          this.style.color = '#FFF';
          
          if (data.sections && data.sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            if (bubble) {
               var d = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
               var i = d.querySelector('.shopify-section');
               if (i) bubble.innerHTML = i.innerHTML;
            }
          }
          
          setTimeout(() => closeQuickView(), 1200);
        })
        .catch(() => {
          this.textContent = 'Errore';
          setTimeout(() => {
            this.textContent = 'Riprova';
            this.style.opacity = '1';
            this.style.pointerEvents = 'auto';
          }, 2000);
        });
      });
    }
  }
});
